<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-full-width table-responsive">
            <template slot="header">
              <div class="row">
                <div class="col-10">
                  <h4 class="card-title">Bana ait Mail Hesapları</h4>
                  <p class="card-category">Müşterilere mail göndermek için bu mail adresleri kullanılacaktır.</p>
                </div>
                <div class="col-2">
                  <button type="submit" class="btn btn-success btn-fill float-right mr-3" @click="createNew()">
                    Yeni Oluştur
                  </button>
                </div>
              </div>

            </template>


            <table class="table table-hover table-striped">
              <thead>
                <slot name="columns">
                  <tr>
                    <th v-for="column in tableColumns" :key="column">{{ column }}</th>
                  </tr>
                </slot>
              </thead>
              <tbody>
                <tr v-for="(item) in tableData" :key="item._id">
                  <slot :row="item">
                    <td>{{ item.mail }}</td>
                    <td>{{ item.host }}</td>
                    <td>{{ item.port }}</td>
                    <td>{{ item.isActive }}</td>
                    <td @click="openDeleteModal(item)"><button><i class="nc-icon nc-simple-remove"></i></button></td>
                    <td @click="editFromMail(item._id)"><button><i class="nc-icon nc-settings-tool-66"></i></button></td>

                  </slot>
                </tr>
              </tbody>
            </table>

            <nav aria-label="...">
              <ul class="pagination text-center" style="margin-left: 45%;">

                <li class="page-item"
                  v-for="i of (pagination.totalPages > 1 ? Array.from(Array(pagination.totalPages).keys()).slice(pagination.currentPage > 3 ? pagination.currentPage - 3 : 0, pagination.currentPage + pagination.layOutMax) : [0])"
                  :key="i"
                  :class="pagination.currentPage == i + 1 ? 'active' : ''" @click="paginationGet(i + 1)"><a
                    class="page-link">{{ i + 1 }}</a></li>



              </ul>
            </nav>
          </card>

        </div>
      </div>


      <div class="modal fade show bg-gray" tabindex="-1"
        :style="deleteModal.isOpened == true ? 'display: block;' : 'display: none;'" aria-modal="true" role="dialog">
        <div class="modal-dialog" v-if="deleteModal.mail">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLiveLabel">Maili silmek istediğinize emin misiniz?</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="deleteModal = false">
                <span aria-hidden="true">×</span>
              </button>
            </div>

            <div class="modal-body">
              <label><strong>Mail:</strong> {{ deleteModal.mail.mail }}</label><br>


            </div>
            <div class="modal-footer">

              <button type="button" @click="openDeleteModal(null)" class="btn btn-secondary"
                data-dismiss="modal">Kapat</button>
              <button type="button" @click="deleteFromMail(deleteModal.mail._id)" class="btn btn-primary">Sil!</button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue'
import CollectionService from "../../services/collection.service.js";

const tableColumns = ['Mail', 'Host', 'Port', 'Aktif mi?']
export default {
  components: {
    Card
  },
  data() {
    return {
      tableColumns,
      tableData: [],
      deleteModal: {
        isOpened: false,
        mail: null
      },
      pagination: {
        currentPage: 1,
        totalPages: 0,
        itemsPerPage: 10,
        layOutMax: 3
      },
    }
  },
  mounted() {
    this.getFromMails();
  },
  methods: {
    paginationGet(i) {
      this.pagination.currentPage = Number(i);
      this.getFromMails();
      window.scroll({ top: 0, behavior: "smooth" })
    },
    getFromMails() {
      let q = { };
      let p = {};
      let o = { skip: (this.pagination.currentPage - 1) * this.pagination.itemsPerPage, limit: this.pagination.itemsPerPage, sort: { createdAt: 1 } }

      let query = `q=${JSON.stringify(q)}&p=${JSON.stringify(p)}&o=${JSON.stringify(o)}`

      CollectionService.getCollection('frommail', query).then((res) => {
        if (res.success == true) {
          this.tableData = res.fromMails;
          this.pagination.totalPages = Math.ceil(res.count / this.pagination.itemsPerPage);
        } else {

          console.log('error');
        }
      })
    },
    createNew() {
      this.$router.push(`/admin/fromMails/create`);
    },
    editFromMail(_id) {
      this.$router.push(`/admin/fromMails/${_id}`);
    },
    deleteFromMail(_id) {
      CollectionService.deleteItem('frommail', _id).then((res) => {
        this.notifyVue('bottom', 'right', 'danger', ` ${this.deleteModal.mail.mail} maili silindi.`)
        this.deleteModal.isOpened = false;
        this.deleteModal.mail = null;
        this.getFromMails();
      })
    },
    openDeleteModal(mail) {
      this.deleteModal.isOpened = !this.deleteModal.isOpened
      this.deleteModal.mail = mail;
    },
    notifyVue(verticalAlign, horizontalAlign, type, message) {
      this.$notifications.notify(
        {
          message: JSON.stringify(message),
          icon: '',
          horizontalAlign: horizontalAlign,
          verticalAlign: verticalAlign,
          type
        })
    },
  }
}
</script>
<style></style>